module.exports = __webpack_public_path__ + "static/media/index.6914370c.png";